// Module
var code = `<!-- HERO — v2 RATIFIED (copy of record 2026-08-13) · evolve-band added 2026-08-22 · three-unit structure 2026-08-22 · feature pair 2026-08-22 -->
<section aria-labelledby="hero-headline">
    <div class="hero-unit hero-unit--identity">
        <h1 class="hero-headline landing-headline"><span class="landing-eyebrow">SIX YEARS IN FORTUNE 100 PRODUCTION · OPEN SOURCE</span>The Behavior-First<br>Frontend Framework</h1>
        <p class="hero-sub-1">SpyneJS elevates Behavior to the level of Views, <br>so structure is defined in the code</p>
    </div>

    <div class="hero-unit hero-unit--action">
        <p class="hero-spec-line">The Codebase is the Spec</p>
        <div class="cta-buttons">
            <a data-channel="ROUTE"
               data-event-prevent-default="true"
               data-page-id="configure"
               href="/configure"
               class="landing-btn landing-btn-primary">Start with an Application Shell</a>
            <a data-channel="ROUTE"
               data-event-prevent-default="true"
               data-page-id="docs"
               data-stage="examples"
               data-text="Docs"
               href="/docs/examples"
               class="landing-btn landing-btn-outline">Learn from Examples</a>
            <div class="cli-snippet">
                <div class="code-container">
                    <code>npx spyne-cli create-app</code>
                    <button type="button" aria-label="Copy command">⧉</button>
                </div>
            </div>
        </div>
    </div>

    <div class="hero-unit hero-unit--context">
        <ul class="landing-tile-grid landing-tile-grid--2" aria-label="What SpyneJS gives you">
            <li class="landing-tile">
                <h2 class="landing-tile__name">Evolve applications without the guesswork</h2>
                <p class="landing-tile__body">SpyneJS precisely defines your application &mdash; and reveals exactly where any feature lives. For developers, for agents, for anyone accountable for the system: audit it, trace it, prove what it does.</p>
            </li>
            <li class="landing-tile">
                <h2 class="landing-tile__name">Runs anywhere, connects to your systems</h2>
                <p class="landing-tile__body">A SpyneJS application is a complete and coherent unit. Deploy it on any CDN, any cloud, or your own infrastructure. Connect it — full read and write — to the databases, APIs, and services you already run. Nothing to re-platform, nothing to buy.</p>
            </li>
        </ul>
    </div>
</section>
`;
// Exports
module.exports = code;